import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/logo/logo1.jpg';

const NotFound = () => {
    return (
        <div className="text-center d-flex align-items-center" style={{ backgroundColor: '#1a3d5d', color: 'white', height: '1000px' }}>
            <div style={{width: '100%'}}>
                <img width="100px" src={logo} alt="" /><br /><br />
                <h2 className="text-center">Sorry, your requested page is not found</h2><br />
                <h4>I am Roky Das. It is my personal website. Go to <Link to='/'>Home page</Link></h4><br />
                <h4>If there is anything wrong, please contact with me <Link to="/contact">Here</Link></h4><br />
            </div>
        </div>
    );
};

export default NotFound;